import React,{  PureComponent, } from 'react'
import {Spin, Button, message, Modal} from "antd";
import { renderFileType } from "@components/UploadFile/UploadImage/file.util";
import { postHttpAction } from '@utils/utils';
import Lang from "@components/Lang/Lang";
import './index.less';
import moment from "moment";

/**
 * 查看 证书详情
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 **/
class CertificateDetail extends PureComponent { 
    static defaultProps = {
        id:"", // 单号，有此单号会请求接口 显示数据
        type:"",// 默认空，若为show 即进入查询内容并显示黄色背景框 信息
    };
    constructor(props) {
        super(props);
        this.state = {
            showModalDetail: false,
            loading:false
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /** 打开信息弹窗*/
    openModalDetail(flag=false) {
        const { item={} } = this.state;
        if(flag&&!item.id){
            this.getDetail();
        }
        this.setState({
            showModalDetail: flag,
        })
    }
    /*
     * 证书詳情
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8034
     *
     * */
    getDetail(){
        if(this.props.id){
            this.loading(true);
            postHttpAction('/service/mg/certificate/query-detail', {
                id:this.props.id
            }, (resData) => {
                this.loading(false);
                const { success, valid,model={}} = resData;
                if (success &&valid) {
                    this.setState({
                        item:model
                    })
                }else if(resData.message){
                    message.warning(resData.message)
                }
            });
        }
    }
    rendItem(title,children){
        return(<div className={"mt_20"}>
                <div className={"mb_4"}>
                    {title}
                </div>
                {children}
            </div>)
    }
    rendCertItem(certName,fileUrl){
        return(<div className={"fileBox flex-item-ver-center mt_8"}>
                {renderFileType(fileUrl,32)}
                <a className={"ml_4 black66"} href={fileUrl} target={"_blank"} title={certName}>
                    {certName}
                </a>
        </div>)
    }
    componentWillMount() {
        if(this.props.type=="show"){
            this.getDetail();
        }
    };
    render() {
        const {loading, showModalDetail, item={ abbreviate:"" }, } = this.state;
        const { id, type }=this.props;
        const sCountryUrl =item.abbreviate?require('../../../../assets/img/country/'+item.abbreviate + '.png'):"";
        return (<>
            {type=="show"?<div className={"mt_12 waringInfo cursor-p"} onClick={()=>this.openModalDetail(true)}>
                        <div className={"flex-item-ver-center"}>
                            {item.abbreviate?<img className="mr_4" src={sCountryUrl.default} width={24} />:null}
                            {item.countryName}<span className={"ml_6 fw_700"}>{item.code}</span>
                            <span className={"ml_6 black66 font_12"}>
                                {item.effectiveBeginTime?moment(item.effectiveBeginTime).format('YYYY.MM.DD'):'/'}
                                <span className={"ml_2 mr_2"}>-</span>
                                {item.effectiveEndTime?moment(item.effectiveEndTime).format('YYYY.MM.DD'):'/'}
                            </span>
                        </div>
                        <div className={"cateUl"}>
                            {item.categoryList&&item.categoryList.length>0?<>
                                {item.categoryList.map((cate={},inx)=><li key={inx}>{cate.categoryName}</li>)}
                            </>:null}
                        </div>
                </div>:<Button className={"mr_8"} onClick={()=>this.openModalDetail(true)}>
                {Lang({id: 'XiangQing', default: '详情'})}
                </Button>}
            {/* 物流信息  */}
            {showModalDetail&&<Modal visible={showModalDetail}
                                        width={600}
                                        centered={true}
                                        // getContainer={false}
                                        title={Lang({id:"ZhengShuXiangQing",default:"证书详情"})}
                                        onCancel={() =>this.openModalDetail(false,[])}
                                        footer={null}>
                <Spin spinning={loading}>
                    <div className={"black89 font_14 popCertificateDetail"}>
                        <div className={"bgGreyBox"}>
                            <div className={"flex-item-ver-center mb_4"}>
                                {item.abbreviate?<img className="mr_4" src={sCountryUrl.default} width={24} />:null}
                                {item.countryName}
                            </div>
                            <p className={"mb_4 fw_500"}>{item.code}</p>
                            <p className={"black66"}>
                                {item.effectiveBeginTime?moment(item.effectiveBeginTime).format('YYYY.MM.DD'):'/'}
                                <span className={"ml_2 mr_2"}>-</span>
                                {item.effectiveEndTime?moment(item.effectiveEndTime).format('YYYY.MM.DD'):'/'}
                            </p>
                        </div>
                        {this.rendItem(Lang({id:"ShiYongLeiMu",default:"适用类目"}),<div className={"cateUl"}>
                            {item.categoryList&&item.categoryList.length>0?<>
                                {item.categoryList.map((cate={},inx)=><li key={inx}>{cate.categoryName}</li>)}
                            </>:null}
                        </div>)}
                        {this.rendItem(Lang({id:"ZhengShuBeiZhu",default:"证书备注"}),<div className={"black45"}>
                            {item.remark||"-"}
                        </div>)}
                        {this.rendItem(Lang({id:"ZhengShuWenJian",default:"证书文件"}),<div className={"black66"}>
                            {(item.attachment||[]).map(cur=>this.rendCertItem(cur.fileName,cur.fileUrl))}
                        </div>)}

                    </div>
                </Spin>
            </Modal>}
        </>);
    }
}

export default CertificateDetail;
